import { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useFamily } from '@/hooks/useFamily';

interface ConditionalLoadingProps {
  children: ReactNode;
  fallback?: ReactNode;
  showFamilyCreate?: boolean;
}

export const ConditionalLoading = ({ 
  children, 
  fallback,
  showFamilyCreate = false 
}: ConditionalLoadingProps) => {
  const { user, loading: authLoading } = useAuth();
  const { family, loading: familyLoading } = useFamily();

  // Don't show "create family" if we're still loading auth or family data
  if (authLoading || (user && familyLoading)) {
    return fallback || (
      <div className="flex items-center justify-center min-h-[200px]">
        <div className="text-center space-y-3">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-sm text-muted-foreground">Chargement...</p>
        </div>
      </div>
    );
  }

  // Only show family creation prompt if explicitly requested and no family exists
  if (showFamilyCreate && user && !family) {
    return children;
  }

  // If family exists or we're not showing family create, show children
  if (family || !showFamilyCreate) {
    return <>{children}</>;
  }

  // Default: don't show anything if no family and not explicitly showing create
  return fallback || null;
};